import * as cartConstants from '../Constants/cartConstants';
import * as shippingConstants from '../Constants/shippingConstants';

export const cartReducer = (state = { cartItems: [], shippingAddress: {}, shippingPrice: {} }, action) => {
  switch (action.type) {
    case cartConstants.ADD_TO_CART_ITEM:
      const item = action.payload;
      

      const existItem = state.cartItems.find((x) => x.productId === item.productId);
     
      

      if (existItem) {
        return {
          ...state,
          cartItems: state.cartItems.map((x) => (x.productId === existItem.productId ? item : x)),
        };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, item],
        };
      }
    case cartConstants.CART_REMOVE_ITEM:
      return {
        ...state,
        cartItems: state.cartItems.filter((x) => x.productId !== action.payload),
      };
    case cartConstants.CART_SAVE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: action.payload,
      };
    /* case cartConstants.CART_SAVE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      }; */
    case cartConstants.CART_RESET:
      return {
        cartItems: [],
        shippingAddress: {},
        
        // paymentMethod: '',
      };
    default:
      return state;
  }
};

export const shippingReducer = (state = {  shippingAddress: {}, shippingAreas: {} }, action) => {
  switch (action.type) {
    case shippingConstants.ADD_TO_SHIPPING_ITEM:
      const area = action.payload;
      

      const existArea = state.shippingAreas.find((x) => x.shippingd === area.shippingId);
     
      

      if (existArea) {
        return {
          ...state,
          shippingAreas: state.shippingAreas.map((x) => (x.shippingId === existArea.shippingId ? area : x)),
        };
      } else {
        return {
          ...state,
          shippingAreas: [...state.shippingAreas, area],
        };
      }
  
    case shippingConstants.SHIPPING_SAVE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: action.payload,
      };
    /* case cartConstants.CART_SAVE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      }; */
    case shippingConstants.SHIPPING_RESET:
      return {
        area: [],
        shippingAddress: {},
        shippingAreas: {},
        // paymentMethod: '',
      };
    default:
      return state;
  }
};